var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipPath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 175,
    viewBox: "0 0 233 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.1942 54.7481C40.1776 53.5103 10.9996 52.9377 11 60.2652C11.0005 68.4345 60.0813 63.3421 58.5066 70.4505C56.9318 77.559 11 71.6176 11 77.8773C11 87.0016 61 79.8322 61 89.654C61 99.4149 11 90.2906 11 100.582C11 108.221 61 105.993 61 112.253C61 118.512 13.8871 111.404 11 127",
    stroke: "#718095",
    strokeOpacity: 0.2,
    strokeWidth: 14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1942 54.7481C40.1776 53.5103 10.9996 52.9377 11 60.2652C11.0005 68.4345 60.0813 63.3421 58.5066 70.4505C56.9318 77.559 11 71.6176 11 77.8773C11 87.0016 61 79.8322 61 89.654C61 99.4149 11 90.2906 11 100.582C11 108.221 61 105.993 61 112.253C61 118.512 13.8871 111.404 11 127",
    stroke: "#DDDDDD",
    strokeOpacity: 0.7,
    strokeWidth: 14
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 49C106.562 57.3793 89.9996 55.646 90 63.675C90.0005 72.6265 133.639 58.9037 136.27 66.409C138.794 73.608 90 76.1143 90 82.9733C90 92.9711 143 74.8442 143 85.6064C143 96.3018 95.0476 93.927 95.0476 105.204C95.0476 113.574 143 100.993 143 107.852C143 114.711 104.87 114.911 102.198 132",
    stroke: "#DDDDDD",
    strokeOpacity: 0.7,
    strokeWidth: 13
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M215.068 44C215.068 50.2675 226.641 62.4532 221.829 63.1732C215.813 64.0733 201.525 47.3315 201.713 53.0922C201.901 58.8528 225.775 72.3542 219.947 76.3147C215.248 79.5085 189.305 50.3919 185.922 56.6925C181.834 64.3031 227.655 88.1959 219.947 90.5362C212.24 92.8764 175.959 56.8726 176.335 66.9537C176.711 77.0347 224.083 94.3166 216.94 102.778C211.119 109.671 176.602 74.4176 173.514 83.5154C171.07 90.7162 220.513 109.438 213.181 115.739C205.849 122.04 172.932 91.6163 172.011 99.5371C171.445 104.398 193.818 115.739 193.818 126",
    stroke: "#DDDDDD",
    strokeOpacity: 0.7,
    strokeWidth: 11
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipPath);
export default __webpack_public_path__ + "static/media/clip-path.7f2e3ad817ed6e2697b7664bd5dfdc7f.svg";
export { ForwardRef as ReactComponent };